// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-page-praktikum[data-v-8e505c86]{padding-top:60px}.job-page-praktikum__back-btn[data-v-8e505c86]{left:0;position:fixed;top:0;z-index:6}.job-page-praktikum__title-media[data-v-8e505c86]{max-width:1200px}.job-page-praktikum__title-media--one-media[data-v-8e505c86]{max-width:600px}.job-page-praktikum__datepicker[data-v-8e505c86]{margin-top:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
